import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgUnleashed = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width="320px"
    height="130px"
    viewBox="0 0 320 130"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="m37.397 65.69 7.994 3.018v30.027L10 85.268l27.397-19.579ZM10 50.577l27.61 10.44v2.696L10 83.449V50.58Z"
        fill="#A41D2A"
      />
      <path
        d="M73 46.286v32.87l-27.61 19.58V66.021L73 46.286Zm158.705 7.699-3.554 4.883a11.714 11.714 0 0 0-7.385-2.65c-1.846 0-2.77.647-2.77 1.745 0 3.102 14.272.757 14.272 10.154 0 5.068-3.748 8.437-10.523 8.437-5.059-.037-8.622-1.662-11.16-4.016l3.443-5.076a11.428 11.428 0 0 0 8.095 3.332c2.197 0 3.563-.757 3.563-2.003 0-3.333-14.27-.563-14.27-10.302 0-4.237 3.553-8.021 10.033-8.021a15.397 15.397 0 0 1 10.256 3.517ZM95.662 50.809v14.77c0 2.99 1.846 5.15 5.335 5.15 3.49 0 5.298-2.16 5.298-5.15v-14.77h6.591V65.8c0 6.286-3.784 10.708-11.89 10.708-8.104 0-11.953-4.459-11.953-10.662V50.81h6.619Zm26.953 0 10.219 13.893V50.809h6.544v25.256h-6.258l-10.68-14.603v14.603h-6.508V50.809h6.683Zm27.739 0v19.57h10.154v5.676l-16.662.01V50.809h6.508Zm31.246 0v5.686h-12v3.933h11.732v5.649H169.6v4.274h12v5.677l-18.508.037V50.809H181.6Zm19.588 0 9.498 25.256h-7.384l-1.247-3.637h-9.95l-1.247 3.637h-7.384l9.498-25.256h8.216Zm40.68 0v9.425h10.486v-9.425h6.517v25.256h-6.517V65.91h-10.486v10.154h-6.508V50.809h6.508Zm40.07 0v5.686h-12v3.933h11.733v5.649h-11.733v4.274h12v5.677l-18.516.037V50.809h18.516Zm14.4 0c7.948 0 13.662 4.773 13.662 12.61 0 7.836-5.714 12.646-13.625 12.646h-10.643V50.809h10.606Zm.028 5.686h-4.126v13.847h4.09a6.702 6.702 0 0 0 7.005-6.924c0-3.895-2.353-6.923-6.969-6.923Zm-99.277.757-3.221 9.508h6.397l-3.176-9.508ZM37.61 31 73 44.477l-27.388 19.57-8.003-3.029L10 50.578 37.61 31Z"
        fill="#E31937"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgUnleashed);
export default ForwardRef;
